import type { OperationStatusIcon } from '@/shared/types';
import { useDictionary } from './useDictionary';

const useOperationStatusIcons = () => {
  const {
    data: operationsStatusIconsData,
    isLoading: isOperationStatusIconsLoading,
    refetch: refetchOperationStatusIcons,
  } = useDictionary<Array<OperationStatusIcon>>({
    dictionaryName: 'operationstatusicons',
  });

  return {
    operationsStatusIconsData,
    isOperationStatusIconsLoading,
    refetchOperationStatusIcons,
  };
};

export { useOperationStatusIcons };
